import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/palfed': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M384.9 193.9C384.9 146.5 329.7 149.7 289.5 164.1 288.2 203.5 287 244.8 286.5 283.9 287.2 286.7 289.1 290.1 301.6 290.1 338.4 290.1 385 247.3 384.9 193.9zM190.4 266.1C190.6 266.1 196.9 263.4 201.6 263.4 228.2 263.4 222.3 307.5 187.2 307.5 165.7 307.5 150.1 289.4 150.1 264.5 150.1 222.5 193 168.9 250.8 138 251.8 125.6 253.8 116 261.3 109.8 272.5 100.8 287.9 106.3 290.8 120.9 363 98.7 426 121.9 426 192.9 426 270.8 346.7 345.5 285.9 331.1 285.8 370.5 286.8 405.5 288.6 431.1V431.3C288.8 434.7 289.2 443.8 283.3 450.4 273.7 461 249.9 460.4 246.9 428.1 242.8 383.7 247.1 222 248.3 185.6 226.8 200.6 189.8 235.9 189.8 261.5 190 264 190.2 265.5 190.4 266.1zM8 181.1S7.9 218.5 46.4 218.5H76.4L98.8 435.7S98.8 480 143.5 480H432.4S477.1 479.6 477.1 435.7L499.5 218.5H529.5S567.9 219.7 567.9 181.1C567.9 181.1 568 143.7 529.5 143.7H499.4C492.1 118.1 469.2 69.4 380 69.4H352V50.3S349.3 31.9 330.9 31.9H245.1S224 31.9 224 50.3V69.4H195.9S90.9 73.6 75.4 143.7H46.4S8 142.5 8 181.1z'
      }
    ]
  }
})
